<template>
	<div>
		<!--<div class="vh-100 bg-grey p-d-72">-->
		<div class="vh-100 bg-grey">
			<SOTitleBar
				:page-title="'E-payment'"
				:type="'back'"
				@back="back"
			/>

			<div class="content-wrapper main-page list-transaksi-epayment-content">
				<div class="p-x-20 p-y-16 bg-white" v-if="listTransaksiEpayment.data !== undefined">
					<div class="f-regular f-14 f-c-midgrey m-d-4">
						Saldo E-payment {{ listTransaksiEpayment.data.nama_deposit }}
					</div>
					<div class="f-bold f-18 f-c-black m-d-4">
						{{ listTransaksiEpayment.data.saldo_epayment | currency }}
					</div>
					<div class="f-regular f-14 f-c-midgrey" v-if="listTransaksiEpayment.data.masa_aktif_raw !== null">
						Aktif {{
							($moment(listTransaksiEpayment.data.masa_aktif_raw).format("YYYY") > 2045) ? 'Selamanya' : 'hingga ' + listTransaksiEpayment.data.masa_aktif_formated
						}}
					</div>
				</div>

				<div class="d-flex p-x-20 p-y-12">
					<div class="f-regular f-16 f-c-midgrey">
						Riwayat Aktivitas
						<span class="m-l-4 m-r-4">•</span>
					</div>
					<div>
						<SODropdown
							:id="'dropdown-transaksi-deposit'"
							:title="dropdownItems[dropdownItems.findIndex(a => a.selected === true)].title"
							:items="dropdownItems"
							@update-data="(val) => { dropdownItems = val }"
							@action="doFilter"
						/>
					</div>
				</div>

				<div class="p-x-20" :class="{'bg-white': !pageSetting.loading.list}">
					<SOCardPaketDepositSkeleton v-if="pageSetting.loading.list"/>

					<SOEmptyState
						v-if="listTransaksiEpayment.data.list_transaksi_epayment.length === 0 && !pageSetting.loading.list"
						:message="'Data tidak ditemukan'"
					/>

					<SOCardTransaksiEpaymentTransaksi
						v-if="!pageSetting.loading.list && listTransaksiEpayment.data !== undefined"
						v-for="transaksi in listTransaksiEpayment.data.list_transaksi_epayment"
						:key="transaksi.idtransaksi"
						:transaksi="transaksi"
						@detail="(transaksiEpayment) => {
              if (transaksi.title === 'Transaksi Self Service') {
                detailTransaksiSelfService(transaksi.idtransaksi);
              } else {
                transaksiEpayment ?
                  detailTransaksi(transaksi.idtransaksi) :
                  detailTopUp(transaksi.idtransaksi)
              }
            }"
					/>

					<SOLoadMoreLoading :id="'loading-list-transaki-epayment'" :loading="pageSetting.loading.loadMore"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex"
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";
import SODropdown from "@/so-components/global/ui/SODropdown";
import SOCardPaketDepositSkeleton from "@/so-components/modules/paket-deposit/SOCardPaketDepositSkeleton";
import SOCardTransaksiEpaymentTransaksi
	from "@/so-components/modules/transaksi-epayment/SOCardTransaksiEpaymentTransaksi";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";

const defaultDropdownItems = () => (
	[
		{
			title: "Semua",
			selected: true,
		},
		{
			title: "Transaksi",
			selected: false,
		},
		{
			title: "Top Up",
			selected: false,
		},
	]
)

export default {
	name: "TransaksiEpayment",
	components: {
		SOTitleBar,
		SOEmptyState,
		SODropdown,
		SOCardPaketDepositSkeleton,
		SOCardTransaksiEpaymentTransaksi,
		SOLoadMoreLoading,
	},
	computed: {
		...mapGetters("epaymentModule", {
			listTransaksiEpayment: "getListTransaksiEpayment",
			pagination: "getPagination",
		}),
	},
	data() {
		return {
			idcustomer: "",

			dropdownItems: defaultDropdownItems(),

			pageSetting: {
				loading: {
					list: true,
					loadMore: false,
				},
				error: {
					list: false,
				}
			}
		}
	},
	async mounted() {
		await this.flushData()
		this.setDefaultFilter()

		this.idcustomer = this.$route.params.idcustomer

		await this.getTransaksiEpayment()
		this.scroll()
	},
	methods: {
		back() {
			// this.$router.push("/konsumen/detail/" + this.idcustomer)
			this.$router.back()
		},

		async getTransaksiEpayment() {
			const res = await this.$store.dispatch("epaymentModule/fetchListTransaksiEpayment", {
				idcustomer: this.idcustomer,
				tipe: this.dropdownItems.findIndex(a => a.selected === true)
			})
			if (!this.pageSetting.loading.list) {
				this.pageSetting.loading.loadMore = true
			} else {
				this.pageSetting.loading.list = false;
			}
			this.pageSetting.loading.loadMore = false
			this.$store.commit("helper/setScrollCalled", false)
			if (res.success) {
				this.pageSetting.error.list = false
				await this.$store.commit("epaymentModule/setNextPagination", {
					data: this.listTransaksiEpayment.data.list_transaksi_epayment
				})
			} else {
				this.pageSetting.error.list = true
				setTimeout(() => {
					this.pageSetting.error.list = false
				}, 10000)
				this.$toast.error(res.err)
			}
		},
		setDefaultFilter() {
			let query = this.$route.query
			if (Object.keys(query).length > 0) {
				this.dropdownItems.forEach((val, key) => {
					if (key.toString() !== query.tipe) {
						this.dropdownItems[key].selected = false
					} else {
						this.dropdownItems[key].selected = true
					}
				})
			} else {
				this.dropdownItems = defaultDropdownItems()
			}
		},
		scroll() {
			window.onscroll = async () => {
				if (this.pageSetting.error.list) {
					return
				}
				let payload = {
					idLoadMore: "loading-list-transaki-epayment",
					container: "list-transaksi-epayment-content",
					pagination: this.pagination,
					callback: this.getTransaksiEpayment,
				}
				await this.$store.dispatch("helper/scroll", payload)
			}
		},
		detailTransaksi(id) {
			this.$router.push("/transaksi/reguler/detail/" + id)
		},
		detailTopUp(id) {
			this.$router.push("/transaksi/epayment/topup/" + id)
		},
    detailTransaksiSelfService(id) {
      this.$router.push("/transaksi/snapclean/detail/" + id)
    },

		async doFilter() {
			this.pageSetting.loading.list = true
			// await this.$store.commit("epaymentModule/resetListTransaksiEpayment")
			this.listTransaksiEpayment.data.list_transaksi_epayment = []
			await this.$store.commit("epaymentModule/resetPagination")
			await this.getTransaksiEpayment()
		},

		async flushData() {
			await this.$store.commit("epaymentModule/resetListTransaksiEpayment")
			await this.$store.commit("epaymentModule/resetPagination")
			this.dropdownItems = defaultDropdownItems()
		}
	},
	beforeDestroy() {
		this.flushData()
	}
}
</script>